// @flow

import TaskListApi from "../../api/TaskListApi/TaskListApi";

class TaskListService {

    taskListApi: TaskListApi;

    constructor(taskListApi: TaskListApi) {
        this.taskListApi = taskListApi;
    }

    async getAllTaskLists() : Promise<Array<Object>> {
        return await this.taskListApi.getAll();
    }

    async duplicateTaskList(request: Object) : Promise<Object> {
        return await this.taskListApi.duplicate(request);
    }

    async applyTaskGroupPriceOffset(request: Object) : Promise<Object> {
        return await this.taskListApi.applyPriceOffset(request);
    }
}

export default TaskListService;
